import React, {useEffect, useState} from "react";
import {Modal, Table} from "react-bootstrap";
import AlertBox from "../../../alert-box/alertBox";
import {instance} from "../../../../utils/utils";
import DateRangePicker from "../../../date-range-picker/date-range-picker";
import "./recent-activities-modal.css";
import LogDetailModal from "./log-detail-modal";
import Tooltip from "../../../tooltip/tooltip";


const RecentActivitiesModal = ({show, onClose}) => {
    const [usersLogs, setUsersLogs] = useState({ count: 0, results: [] });
    const [page, setPage] = useState(1);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isDateMenuOpen, setIsDateMenuOpen] = useState(false);
    const [paginatedLogs, setPaginatedLogs] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);

    const [filters, setFilters] = useState({
        role: null,
        preset: null,
        start: null,
        end: null,
    });

    const pageSize = 10;
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + paginatedLogs.length;

    const handlePrevPage = () => page > 1 && setPage(page - 1);
    const handleNextPage = () => page < totalPages && setPage(page + 1);

    const truncateText = (text, maxLength = 60) => {
        if (!text) return "";
        return text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
    };

    const getUsersLogs = (f = filters) => {
        const appliedFilters = f || filters;
        const params = new URLSearchParams();

        if (appliedFilters.role) params.append("role", appliedFilters.role);
        if (appliedFilters.start && appliedFilters.end) {
            params.append("start", appliedFilters.start);
            params.append("end", appliedFilters.end);
        }
        if (appliedFilters.preset) params.append("preset", appliedFilters.preset);
        if (appliedFilters.email) params.append("email", appliedFilters.email);

        instance
            .get(`memberships/logs/?${params.toString()}`)
            .then((res) => res.data)
            .then((data) => setUsersLogs(data))
            .catch((err) => console.error(err));
    };

    const handleFilterChange = (filterType, value) => {
        setIsUserMenuOpen(false);
        setIsDateMenuOpen(false);

        if (filterType === "custom") {
            setShowDateRangePicker(true);
            return;
        }

        if (filterType === "clearDate") {
            const clearedFilters = { ...filters, start: null, end: null, preset: null };
            setFilters(clearedFilters);
            setPage(1);
            getUsersLogs(clearedFilters);
            return;
        }

        setFilters((prev) => {
            const newFilters = {
                ...prev,
                [filterType]: prev[filterType] === value ? null : value,
            };

            if (filterType === "preset") {
                newFilters.start = null;
                newFilters.end = null;
            }

            if (filterType === "start" || filterType === "end") {
                newFilters.preset = null;
            }

            setPage(1);
            getUsersLogs(newFilters);

            return newFilters;
        });
    };

    useEffect(() => {
        if (usersLogs?.results) {
            const slice = usersLogs.results.slice(
                (page - 1) * pageSize,
                page * pageSize
            );
            setPaginatedLogs(slice);
            setTotalPages(Math.ceil(usersLogs.count / pageSize));
        } else {
            setPaginatedLogs([]);
            setTotalPages(0);
        }
    }, [usersLogs, page]);

    useEffect(() => {
        if (show) {
            setPage(1);
            setFilters({ role: null, preset: null, start: null, end: null });
            getUsersLogs({ role: null, preset: null, start: null, end: null });
        }
    }, [show]);

    return (
        <>
            <Modal
                show={show}
                onHide={onClose}
                centered
                size="lg"
                scrollable
                className="recent-activities-modal"
            >
                <Modal.Header className="position-relative text-center justify-content-center p-4">
                    <span className="recent-activities-modal-title">
                        Actividades Recientes
                    </span>
                    <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                        <svg
                            type="button"
                            className="btn-close recent-activities-modal-close"
                            aria-label="Close"
                            onClick={onClose}
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="27"
                            viewBox="0 0 26 27"
                            fill="none"
                        >
                            <path
                                d="M13 1.5C19.2984 1.5 24.5 6.81872 24.5 13.5C24.5 20.1813 19.2984 25.5 13 25.5C6.70158 25.5 1.5 20.1813 1.5 13.5C1.5 6.81872 6.70158 1.5 13 1.5Z"
                                stroke="#9DACBD"
                                strokeWidth="3"
                            />
                            <path d="M8 8.5L17.5 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M17.5 8.5L8 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                </Modal.Header>

                <Modal.Body className="d-flex flex-column gap-3 px-4">
                    <div className="w-75 align-self-center">
                        <AlertBox
                            title="Historial de Cambios / Actividades Recientes"
                            description="Aquí puedes consultar los registros de acciones realizadas por usuarios con permisos administrativos. Cada entrada incluye la acción realizada, fecha, hora y nombre del responsable."
                            closable={false}
                        />
                    </div>
                    <div className="table-responsive">
                        <Table hover size="sm" className="align-middle">
                            <thead className="table-light">
                            <tr>
                                <th
                                    className="recent-activities-modal-label"
                                >

                                    <div className="dropdown position-relative">
                                        <div
                                            className="recent-activities-modal-label recent-activities-modal-dropdown dropdown-toggle d-flex cursor-pointer p-1 px-2"
                                            onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                                        >
                                            Usuario
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11"
                                                 viewBox="0 0 18 11" fill="none">
                                                <path
                                                    d="M8.99245 10.7731C8.52044 10.7731 8.04838 10.5942 7.68817 10.2361L0.540215 3.13017C-0.180072 2.41411 -0.180072 1.25311 0.540215 0.537039C1.2605 -0.179013 2.42841 -0.179013 3.14871 0.537039L8.99245 6.34647L14.8362 0.537039C15.5565 -0.179013 16.7244 -0.179013 17.4447 0.537039C18.165 1.25311 18.165 2.41411 17.4447 3.13017L10.2967 10.2361C9.93657 10.5942 9.46445 10.7731 8.99245 10.7731Z"
                                                    fill="#9DACBD"/>
                                            </svg>
                                        </div>

                                        {isUserMenuOpen && (
                                            <div
                                                className={`show recent-activities-modal-table-dropdown-menu d-flex flex-column p-2 px-2 gap-1`}
                                            >
                                                Rol
                                                <div
                                                    onClick={() => handleFilterChange("role", "10")}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.role === "10" ? 'active' : ''}`}>
                                                    Super usuario
                                                </div>

                                                <div
                                                    onClick={() => handleFilterChange("role", "20")}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.role === "20" ? 'active' : ''}`}>
                                                    Operativo
                                                </div>

                                                <div
                                                    onClick={() => handleFilterChange("role", "30")}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.role === "30" ? 'active' : ''}`}>
                                                    Prof. de la salud
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </th>
                                <th
                                    className="recent-activities-modal-label"
                                >
                                    Acción Realizada
                                </th>
                                <th
                                    className="recent-activities-modal-label"
                                >
                                    Detalle
                                </th>
                                <th className="recent-activities-modal-label text-center">
                                    <div className="dropdown position-relative">
                                        <div
                                            className="recent-activities-modal-label recent-activities-modal-dropdown dropdown-toggle d-flex cursor-pointer p-1 px-2"
                                            onClick={() => setIsDateMenuOpen(!isDateMenuOpen)}
                                        >
                                            Fecha
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none">
                                                <path
                                                    d="M8.99245 10.7731C8.52044 10.7731 8.04838 10.5942 7.68817 10.2361L0.540215 3.13017C-0.180072 2.41411 -0.180072 1.25311 0.540215 0.537039C1.2605 -0.179013 2.42841 -0.179013 3.14871 0.537039L8.99245 6.34647L14.8362 0.537039C15.5565 -0.179013 16.7244 -0.179013 17.4447 0.537039C18.165 1.25311 18.165 2.41411 17.4447 3.13017L10.2967 10.2361C9.93657 10.5942 9.46445 10.7731 8.99245 10.7731Z"
                                                    fill="#9DACBD"
                                                />
                                            </svg>
                                        </div>

                                        {isDateMenuOpen && (
                                            <div className="show recent-activities-modal-table-dropdown-menu year d-flex flex-column p-2 px-1 gap-1">
                                                <div
                                                    onClick={() => handleFilterChange("preset", "today")}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.preset === "today" ? "active" : ""}`}
                                                >
                                                    Hoy
                                                </div>
                                                <div
                                                    onClick={() => handleFilterChange("preset", "w")}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.preset === "w" ? "active" : ""}`}
                                                >
                                                    Esta semana
                                                </div>
                                                <div
                                                    onClick={() => handleFilterChange("preset", "m")}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.preset === "m" ? "active" : ""}`}
                                                >
                                                    Este mes
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (filters.start && filters.end) {
                                                            handleFilterChange("clearDate", null);
                                                        } else {
                                                            handleFilterChange("custom", "custom");
                                                        }
                                                    }}
                                                    className={`recent-activities-modal-table-dropdown-menu-label cursor-pointer p-1 ${filters.start && filters.end ? "active" : ""}`}
                                                >
                                                    {filters.start && filters.end
                                                        ? `Rango personalizado (${filters.start} → ${filters.end})`
                                                        : "Rango personalizado (Date picker)"}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </th>

                                <th
                                    className="recent-activities-modal-label text-center"
                                >
                                    Hora
                                </th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {paginatedLogs.length > 0 ? (
                                paginatedLogs.map((log, idx) => (
                                    <tr key={idx}>
                                        <td
                                            className="recent-activities-modal-label"
                                        >
                                            {log?.elevva_admin_email}
                                        </td>
                                        <td
                                            className="recent-activities-modal-label-light no-wrap"
                                        >
                                            {log?.log_type_label}
                                        </td>
                                        <td
                                            className="recent-activities-modal-label-light"
                                        >
                                            {truncateText(log?.log_description_admin, 60)}
                                        </td>
                                        <td
                                            className="recent-activities-modal-label-light no-wrap text-center"
                                        >
                                            {log.date}
                                        </td>
                                        <td
                                            className="recent-activities-modal-label-light text-center"
                                        >
                                            {log.time}
                                        </td>
                                        <td className="recent-activities-modal-label-light text-center">

                                                <button className="btn btn-sm btn-link" onClick={() => setSelectedLog(log)}>
                                                    <Tooltip title="Ver detalle">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                             viewBox="0 0 16 16" fill="none">
                                                            <ellipse cx="7.93001" cy="7.78418" rx="7.93001" ry="7.78418"
                                                                     fill="#B5C1CD"/>
                                                            <path
                                                                d="M8.92502 9.53168C8.62259 9.69599 8.31424 9.82319 7.98581 9.89692C6.80447 10.163 5.72659 9.9416 4.77261 9.20576C4.05453 8.6518 3.59585 7.92426 3.44137 7.04194C3.19681 5.64545 3.62875 4.46845 4.72665 3.54169C5.2496 3.10053 5.86349 2.83051 6.54611 2.74677C7.95547 2.57343 9.12137 3.029 10.0201 4.11274C10.4202 4.59516 10.6606 5.15424 10.7594 5.76826C10.8909 6.58515 10.7594 7.36201 10.3588 8.09223C10.3325 8.13959 10.3359 8.16596 10.3749 8.20429C11.0682 8.88203 11.7583 9.56318 12.4528 10.2397C12.6621 10.4433 12.7877 10.6801 12.7909 10.9711C12.7949 11.3581 12.5515 11.7209 12.195 11.8701C11.8124 12.0302 11.3946 11.954 11.0945 11.6628C10.6782 11.258 10.2655 10.85 9.85147 10.4433C9.54373 10.1406 9.23617 9.83784 8.92502 9.53168ZM7.08474 9.03315C8.60775 9.02387 9.80795 7.83515 9.81491 6.36933C9.82205 4.87665 8.60348 3.6955 7.1196 3.68061C5.60843 3.66498 4.37735 4.84955 4.36465 6.33124C4.35214 7.81757 5.55954 9.01899 7.08474 9.03315Z"
                                                                fill="white"/>
                                                            <path
                                                                d="M7.04396 4.40284C7.36043 4.39015 7.5594 4.62159 7.58461 4.84889C7.61287 5.10304 7.40816 5.3545 7.14735 5.37941C7.02962 5.39039 6.90834 5.39601 6.79634 5.42921C6.38472 5.55104 6.11952 5.90187 6.10127 6.33131C6.09096 6.57472 5.96425 6.75367 5.75581 6.81959C5.43318 6.92115 5.10676 6.68556 5.10548 6.34962C5.10231 5.53859 5.64027 4.79078 6.42403 4.52198C6.52449 4.48732 6.62849 4.45997 6.73305 4.44044C6.83534 4.42091 6.9402 4.41481 7.04396 4.40284Z"
                                                                fill="white"/>
                                                        </svg>
                                                    </Tooltip>
                                                </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted recent-activities-modal-label-light">
                                        No se encontraron actividades recientes
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </div>


                    <div className="d-flex justify-content-end align-items-center gap-4 w-75 mt-3 ms-auto">
                    <span className="plans-list-panel-table-labels">
                        {usersLogs.count > 0 ? `${startIndex + 1} - ${endIndex} de ${usersLogs.count}` : "0 de 0"}
                    </span>
                        <div className="d-flex gap-2">
                            <svg
                                className={`bi bi-chevron-left ${
                                    page === 1 ? "text-muted" : "cursor-pointer"
                                }`}
                                onClick={page === 1 ? undefined : handlePrevPage}
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="15"
                                viewBox="0 0 9 15"
                                fill="none"
                                style={{pointerEvents: page === 1 ? "none" : "auto"}}
                            >
                                <path
                                    d="M0.0423059 7.30351C0.0423059 6.92015 0.188535 6.53675 0.481072 6.24419L6.28647 0.438753C6.87147 -0.146251 7.81998 -0.146251 8.405 0.438753C8.99 1.02376 8.99 1.97231 8.405 2.55733L3.65881 7.30351L8.405 12.0497C8.99 12.6347 8.99 13.5832 8.405 14.1683C7.81998 14.7533 6.87147 14.7533 6.28647 14.1683L0.481072 8.36282C0.188535 8.0703 0.0423059 7.68685 0.0423059 7.30351Z"
                                    fill="#9DACBD"
                                />
                            </svg>

                            <svg
                                className={`bi bi-chevron-right ${
                                    page === totalPages || totalPages === 0
                                        ? "text-muted"
                                        : "cursor-pointer"
                                }`}
                                onClick={
                                    page === totalPages || totalPages === 0
                                        ? undefined
                                        : handleNextPage
                                }
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="15"
                                viewBox="0 0 10 15"
                                fill="none"
                                style={{
                                    pointerEvents:
                                        page === totalPages || totalPages === 0 ? "none" : "auto",
                                }}
                            >
                                <path
                                    d="M9.67644 7.30196C9.67644 7.68532 9.53022 8.06872 9.23768 8.36128L3.43228 14.1667C2.84728 14.7517 1.89877 14.7517 1.31375 14.1667C0.72875 13.5817 0.72875 12.6332 1.31375 12.0481L6.05994 7.30196L1.31375 2.55578C0.72875 1.97078 0.72875 1.02223 1.31375 0.437193C1.89877 -0.14781 2.84728 -0.14781 3.43228 0.437193L9.23768 6.24264C9.53022 6.53517 9.67644 6.91862 9.67644 7.30196Z"
                                    fill="#9DACBD"
                                />
                            </svg>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {showDateRangePicker && (
                <DateRangePicker
                    show={showDateRangePicker}
                    handleClose={() => setShowDateRangePicker(false)}
                    onApply={({ start, end }) => {
                        const newFilters = { ...filters, start, end, preset: null };
                        setFilters(newFilters);
                        getUsersLogs(newFilters);
                    }}
                />
            )}

            {selectedLog && (
                <LogDetailModal
                    show={!!selectedLog}
                    log={selectedLog}
                    handleClose={() => setSelectedLog(null)}
                    onViewFullHistory={getUsersLogs}
                />
            )}
        </>
);
};

export default RecentActivitiesModal;
